import React, { ReactNode } from "react"
import { useUserGroups } from "hooks/useUserGroups"
import { useConfig } from "configuration/useConfig"
import { DynamicConfig } from "configuration/config"

interface WithAuthProps {
  children: ReactNode
  requiredGroups: string[]
  configKey?: keyof DynamicConfig
  mode?: "hide" | "disable"
  fallback?: ReactNode
}

export const WithAuth = ({
  children,
  requiredGroups,
  configKey,
  mode = "hide",
  fallback = null
}: WithAuthProps) => {
  const { hasAnyGroup } = useUserGroups()
  const { config } = useConfig()

  if ((!requiredGroups || requiredGroups.length === 0) && !configKey) {
    return null
  }

  if (configKey && !config[configKey]) {
    if (mode === "hide") {
      return <>{fallback}</>
    }
    return (
      <>
        {React.Children.map(children, (child) => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, {
              disabled: true,
              // eslint-disable-next-line
              ...(child.props as any)
            })
          }
          return child
        })}
      </>
    )
  }

  const hasAccess = !requiredGroups || requiredGroups.length === 0 || hasAnyGroup(requiredGroups)

  if (mode === "hide") {
    return hasAccess ? <>{children}</> : <>{fallback}</>
  }

  if (mode === "disable") {
    if (hasAccess) {
      return <>{children}</>
    }

    return (
      <>
        {React.Children.map(children, (child) => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, {
              disabled: true,
              // eslint-disable-next-line
              ...(child.props as any)
            })
          }
          return child
        })}
      </>
    )
  }

  return <>{children}</>
}
